export function formatTRY(amount) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n) + " ₺";
}

export function formatTRYFull(amount) {
  const n = Number(amount || 0);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n) + " ₺";
}

export function formatDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(iso);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}

export function daysUntilLabel(iso) {
  const n = daysUntil(iso);
  if (n === null) return "";
  if (n < 0) return `${Math.abs(n)} gün gecikti`;
  if (n === 0) return "Bugün";
  if (n === 1) return "Yarın";
  return `${n} gün kaldı`;
}

export const TR_MONTHS = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
];

export const productLabel = (p) => {
  const map = { motorin: "Motorin", benzin: "Kurşunsuz 95", lpg: "Otogaz / LPG", aytemiz: "Aytemiz Ödeme" };
  return map[p] || p;
};
